var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 80 80",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9341 0.366981C18.158 0.366975 0.523231 18.0017 0.523231 39.7779C0.523231 61.554 18.158 79.2268 39.9341 79.2268C61.7103 79.2268 79.383 61.554 79.383 39.7779C79.383 18.0017 61.7103 0.366981 39.9341 0.366981ZM30.2049 21.1936C30.7066 21.1936 31.1854 21.2924 31.6111 21.5356L41.3403 27.2743C42.3132 27.8824 42.7845 28.8477 42.7845 29.8206L42.7845 33.9632L38.1859 36.6235L38.1859 32.633C38.1859 31.5384 37.555 30.5351 36.7037 30.0487L31.4971 26.8943C30.5242 26.4078 29.422 26.4078 28.5707 26.8943L23.3261 29.9347C22.3531 30.5427 21.8819 31.508 21.8819 32.481L21.8819 38.5617C21.8819 39.6563 22.4748 40.6596 23.3261 41.146L28.5707 44.3004C29.5436 44.7869 30.6458 44.7869 31.4971 44.3004L38.1859 40.2719L42.7845 37.7256L49.5873 33.6971C50.5603 33.2107 51.6624 33.2107 52.5137 33.6971L62.3569 39.4358C63.3298 40.0439 63.8391 41.0092 63.8391 41.9821L63.8391 53.5356C63.8391 54.6301 63.2082 55.5954 62.3569 56.0819L52.5137 61.8206C51.5408 62.3071 50.4386 62.3071 49.5873 61.8206L39.7441 56.0819C38.7712 55.4738 38.2999 54.5085 38.2999 53.5356L38.2999 49.5071L42.8985 46.8468L42.8985 50.7232C42.8985 51.8178 43.5294 52.8211 44.3807 53.3076L49.5873 56.3479C50.5603 56.8344 51.6624 56.8344 52.5137 56.3479L57.6443 53.3076C58.6173 52.6995 59.0885 51.6962 59.0885 50.7232L59.0885 44.6425C59.0885 43.5479 58.4956 42.5826 57.6443 42.0962L52.3997 39.0558C51.4267 38.5693 50.3246 38.5693 49.4733 39.0558L42.7845 42.9703L38.1859 45.6306L31.4971 49.5071C30.5242 49.9935 29.422 49.9935 28.5707 49.5071L18.7275 43.8064C17.7546 43.1983 17.2453 42.233 17.2453 41.2601L17.2453 29.8206C17.2453 28.8477 17.7546 27.8748 18.7275 27.3883L28.6847 21.5356C29.1712 21.2924 29.7033 21.1936 30.2049 21.1936Z",
    fill: "#8247e5",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.180e17652894f5ffbb96c21627ddb132.svg";
export { ForwardRef as ReactComponent };